module.exports = __webpack_public_path__ + "img/top-arrow.b5b0725.svg";